import { Inject, Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {BasicResponse, Auth0Tenant, SortFilterInterface} from '../..';


export interface TenantAPI {
  items: Auth0Tenant[];
  total_count: number;
}

@Injectable({
  providedIn: 'root'
})
export class Auth0TenantService {

  constructor( @Inject(ConfigService) private config, private httpClient: HttpClient) {
    this.URL = config.REST_SERVER_HOST + config.REST_SERVER_url.find(restUrl => restUrl.api === 'PADM').url;
    this.headers = new HttpHeaders().set('DoNotIntercept', 'true');
  }
  private URL;
  headers: HttpHeaders;

  private static handleHTTPError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
          `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    // return an observable with a user-facing error message
    // return throwError('Something bad happened; please try again later.');
    return throwError(error);
  }


  getTenants(pageIndex: number, pageSize: number, sortActive: string, sort: string, sortFilter: SortFilterInterface): Observable<TenantAPI> {

    const headers = this.headers;
    if ((sortActive === '') || (sort === '')) {
      sortActive = '0';
      sort = 'asc';
    }
    return this.httpClient.post<TenantAPI>(
        `${this.URL}/auth0/tenant/${pageIndex}/${pageSize}/${sortActive}/${sort}`,sortFilter, {headers}).pipe(
        catchError(Auth0TenantService.handleHTTPError)
    );

  }

    updateTenant(tenant: Auth0Tenant): Observable<BasicResponse> {
      const headers = this.headers;
      return this.httpClient.patch<BasicResponse>(`${this.URL}/auth0/tenant/${tenant.id}`,
          tenant, {headers})
          .pipe(
              catchError(Auth0TenantService.handleHTTPError)
          );
    }

  createTenant(tenant: Auth0Tenant): Observable<BasicResponse> {
    const headers = this.headers;
    return this.httpClient.put<BasicResponse>(`${this.URL}/auth0/tenant/`,
        tenant, {headers})
        .pipe(
            catchError(Auth0TenantService.handleHTTPError)
        );
  }

  getTenant(id: number): Observable<Auth0Tenant> {
    const headers = this.headers;
    return this.httpClient.get<Auth0Tenant>(
        `${this.URL}/auth0/tenant/${id}`, {headers}).pipe(
        catchError(Auth0TenantService.handleHTTPError)
    );
  }
}
